import { QrCodeForm } from '@/features/qrCodes'

function QrCodeGenerator() {
  return (
    <div className="flex flex-col gap-4 p-2">
      <h1 className="text-heading2 text-text">QR Code Generator</h1>
      <QrCodeForm />
    </div>
  )
}

export default QrCodeGenerator
